import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProactiveAlertHistoryService {
  baseUrl = environment.baseUrl;
  isHistoryUpdate = false

  constructor(private http: HttpClient) { }


  getAlerts(startDate, endDate, printerInfo) {
    const paramsObject = {
      product_number: printerInfo.product_number,
      serial_number: printerInfo.serial_number,
      start_date: this.formatDate(startDate),
      end_date: this.formatDate(endDate),
    }
    let params = new HttpParams();
    for (let key in paramsObject) {
      params = params.set(key, paramsObject[key]);
    }
    return this.http.get<any>(this.baseUrl + '/services/seals/api/v1/printers/action_required_history', { params });
  }

  formatDate(date) {
    return moment(new Date(date)).utc().format();
  }

  downloadReport(startDate, endDate, printerInfo, format, filter) {
    const paramsObject = {
      product_number: printerInfo.product_number,
      serial_number: printerInfo.serial_number,
      start_date: this.formatDate(startDate),
      end_date: this.formatDate(endDate),
      "status": "Closed",
      device_id: printerInfo.device_id,
      format,
      filter
    }

    let params = new HttpParams();
    for (let key in paramsObject) {
      params = params.set(key, paramsObject[key]);
    }
    return this.http.get<Blob>(this.baseUrl + '/services/seals/api/v1/actions_history', { observe: 'response', responseType: 'blob' as 'json', params })
  }

  getAlertHistory(startDate, endDate, printerInfo) {
    // const paramsObject = {
    //   product_number : "Y0U22B",
    //   serial_number: "MY97F1T00J",
    //   start_date:"2021-08-02 06:01:02.997",
    //   end_date: "2022-08-02 06:01:02.997",
    //   "status": "Closed",
    // }

    const paramsObject = {
      product_number: printerInfo.product_number,
      serial_number: printerInfo.serial_number,
      start_date: this.formatDate(startDate),
      end_date: this.formatDate(endDate),
      "status": "Closed",
    }
    let params = new HttpParams();
    for (let key in paramsObject) {
      params = params.set(key, paramsObject[key]);
    }

    return this.http.get<any>(this.baseUrl + `/services/seals/api/v1/actions_history`, { params })
  }
  getPrinterInkLevelHistory(startDate, endDate, device_id) {

    const paramsObject = {
      start_date: this.formatDate(startDate),
      end_date: this.formatDate(endDate),
      device_id: device_id,
    }
    let params = new HttpParams();
    for (let key in paramsObject) {
      params = params.set(key, paramsObject[key]);
    }

    return this.http.get<any>(this.baseUrl + `/services/core/users/api/v1/printer_ink_histories`, { params })
  }

  createInkLevelHistory(device_id) {
    return this.http.post<any>(this.baseUrl + '/services/core/users/api/v1/create_ink_history', { device_id: device_id });

  }
}
